<template>
  <h5 class="mb-1 fs-7 text-gray-700 mb-2">Авто</h5>
  <div class="podft-list p-4 rounded border mb-3" v-for="item in vehicles">
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> Гос. номер / VIN
        <span class="text-gray-800 float-end" v-html="item.number"></span>
      </div>
    </div>
    <div v-if="item.mark || item.model" class="podft-list__item">
      <div class="text-gray-600 fs-7"> Авто
        <span class="text-gray-800 float-end">
          {{item.mark}}
          {{item.model}}
          {{item.color}}
          {{item.year}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyVehicle',
  props: {
    vehicles: null
  }
}
</script>

<style scoped>

</style>